import { useMemo } from "react";

import { useScreenOrientation } from "./useScreenOrientation";

export const useOrientationLimits = () => {
    const screenOri = useScreenOrientation();

    return useMemo(() => {
        if (screenOri === "portrait") {
            return {
                beta: { min: 75, max: 100 },
                gamma: { min: 0, max: 90, abs: true },
            };
        }

        return {
            gamma: { min: 75, max: 90, abs: true },
        };
    }, [screenOri]);
};
